/**
 * LMP Lightbox Navigation
 * Horizontale Pfeil-Navigation für das Produkt-Lightbox
 *
 * Strategie: Buttons werden direkt in <body> eingefügt (NICHT in <product-modal>),
 * damit der Theme-eigene "pointerup schließt Modal"-Handler nicht ausgelöst wird.
 */
(function () {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Pfeil-Buttons erstellen
    const prevBtn = makeBtn(true);
    const nextBtn = makeBtn(false);
    document.body.appendChild(prevBtn);
    document.body.appendChild(nextBtn);

    function makeBtn(isPrev) {
      const btn = document.createElement('button');
      btn.className = 'lmp-lb-btn ' + (isPrev ? 'lmp-lb-prev' : 'lmp-lb-next');
      btn.setAttribute('type', 'button');
      btn.setAttribute('aria-label', isPrev ? 'Vorheriges Bild' : 'Nächstes Bild');
      btn.style.display = 'none';
      const pts = isPrev ? '15 18 9 12 15 6' : '9 18 15 12 9 6';
      btn.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"' +
        ' fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"' +
        ' stroke-linejoin="round"><polyline points="' + pts + '"></polyline></svg>';
      return btn;
    }

    // Hilfsfunktionen
    function getModal() {
      return document.querySelector('product-modal[open]');
    }

    function getContent(modal) {
      return modal ? modal.querySelector('.product-media-modal__content') : null;
    }

    function getItems(modal) {
      const content = getContent(modal);
      return content ? Array.from(content.querySelectorAll('[data-media-id]')) : [];
    }

    function getCurrentIdx(modal) {
      const content = getContent(modal);
      const items = getItems(modal);
      if (!content || !items.length) return 0;
      const w = content.clientWidth || window.innerWidth;
      return Math.max(0, Math.min(Math.round(content.scrollLeft / w), items.length - 1));
    }

    function goTo(modal, idx) {
      const content = getContent(modal);
      const items = getItems(modal);
      if (!content || idx < 0 || idx >= items.length) return;

      // .active-Klasse aktualisieren (für Mobile-Kompatibilität)
      items.forEach(function (item, i) {
        item.classList.toggle('active', i === idx);
      });

      // Direkt zur neuen Position springen (keine Animation)
      const w = content.clientWidth || window.innerWidth;
      content.scrollLeft = idx * w;
      refreshBtns(modal, idx, items.length);
    }

    function refreshBtns(modal, idx, total) {
      if (idx === undefined) idx = getCurrentIdx(modal);
      if (total === undefined) total = getItems(modal).length;
      const show = total > 1;
      prevBtn.style.display = show ? 'flex' : 'none';
      nextBtn.style.display = show ? 'flex' : 'none';
      prevBtn.disabled = idx <= 0;
      nextBtn.disabled = idx >= total - 1;
      prevBtn.style.opacity = idx <= 0 ? '0.35' : '1';
      nextBtn.style.opacity = idx >= total - 1 ? '0.35' : '1';
    }

    // Modal-Öffnung / -Schließung beobachten
    var observer = new MutationObserver(function () {
      var modal = getModal();
      if (modal) {
        // Kurz warten, bis showActiveMedia() fertig ist (setzt scrollLeft zurück)
        setTimeout(function () {
          var content = getContent(modal);
          var items = getItems(modal);
          if (!content || !items.length) return;

          // Aktives Element anhand der .active-Klasse finden
          var activeItem = content.querySelector('[data-media-id].active');
          var idx = activeItem ? items.indexOf(activeItem) : 0;

          // Direkt auf die richtige Position springen (kein smooth, um Flackern zu vermeiden)
          var w = content.clientWidth || window.innerWidth;
          content.scrollLeft = idx * w;

          refreshBtns(modal, idx, items.length);
        }, 60);
      } else {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
      }
    });

    observer.observe(document.body, {
      attributes: true,
      subtree: true,
      attributeFilter: ['open']
    });

    // Klick-Handler
    prevBtn.addEventListener('click', function () {
      var modal = getModal();
      if (modal) goTo(modal, getCurrentIdx(modal) - 1);
    });

    nextBtn.addEventListener('click', function () {
      var modal = getModal();
      if (modal) goTo(modal, getCurrentIdx(modal) + 1);
    });

    // Tastatur: Pfeiltasten für horizontale Navigation
    document.addEventListener('keydown', function (e) {
      var modal = getModal();
      if (!modal) return;
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        goTo(modal, getCurrentIdx(modal) + 1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goTo(modal, getCurrentIdx(modal) - 1);
      }
    });
  }
})();
